import { inject, injectable } from 'inversify';
import { TYPES } from '@Types';
import { army_organisation_full } from '@Api';
import { ArmyOrganisation } from '@Models';
import { ArmyOrganisationGroupMapper } from './army-organisation-group.mapper';

@injectable()
export class ArmyOrganisationMapper {
  @inject(TYPES.ArmyOrganisationGroupMapper)
  private _organisationGroupMapper!: ArmyOrganisationGroupMapper;

  public map(item: army_organisation_full): ArmyOrganisation {
    return {
      id: item.id,
      name: item.name ?? '',
      is_default: item.is_default,
      army_organisation_groups: item.army_organisation_groups
        .map((item) => this._organisationGroupMapper.map(item))
        .sort((a, b) => a.position - b.position),
    } satisfies ArmyOrganisation as ArmyOrganisation;
  }
}
